import React from 'react';
import CVPromoSection from './CVPromoSection';
import EasyToPlaySection from './EasyToPlaySection';
import FooterSection from './FooterSection';
import GetStartedSection from './GetStartedSection';
import HeroCard from './HeroCard';
import LandingBanner from './LandingBanner';
import './CVLandingPage.scss';

const CVLandingPage = () => {
  return (
    <div className="cv-landing-main-wrapper">
      <LandingBanner />
      <HeroCard />
      <EasyToPlaySection />
      <GetStartedSection />
      <CVPromoSection />
      <FooterSection />
    </div>
  );
};

export default CVLandingPage;
